import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFirstName, setLastName, setToken, setLastLoginDate, setPsoName, setRole, setMfaToken } from "Store/LoginInfoSlice";
import { useNavigate } from "react-router-dom";
import { CloseButton, Col, Modal, Row, Form } from "react-bootstrap";
import { TextButton } from "Components/Button";
import { PageInfo } from "Components/PageInformation/PageInformation";
import { mfaSendToken, mfaVerifyToken } from './MfaTokenPopupAxiosFuncs';
import { ROLES } from "Utils/constants";
import { maskEMail } from 'Utils/utilityFunctions';

const EmailMfaTokenPopup = ({
  show,
  handleClose
}) => {

  const loginInfo = useSelector(state => state.loginInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [emailMfaToken, setEmailMfaToken] = useState("");
  const [showSendCodeMsg, setShowSendCodeMsg] = useState(false);
  const [disableSendCode, setDisableSendCode] = useState(false);
  const [globalErrorList, setGlobalErrorList] = useState([]);
  const [disableMfaTokenField, setDisableMfaTokenField] = useState(true);
  const tokenInputRef = useRef();

  const handleEmailSendCode = async () => {

    // clear error
    setGlobalErrorList([]);
    // disable the send code button to avoid double click renable it after 30s
    setDisableSendCode(true);

    // if no phone number provided, then send the token via the email
    const res = await mfaSendToken(loginInfo.mfaToken, { userFactor: "EMAIL" });

    console.log("handleEmailSendCode()", res);

    if (res && res.data.status !== 200) {
      setGlobalErrorList(res.data.data?.globalErrorMessageList);
      setDisableSendCode(false);
    } else {
      setTimeout(() => {
        setDisableSendCode(false);
      }, 30000);
      setShowSendCodeMsg(true);
      setDisableMfaTokenField(false);
      setTimeout(() => {
        tokenInputRef.current.focus();
      }, 500);
    }
  }

  const handleEmailMfaChange = (e) => {
    let value = e.target.value;
    const regex = /^[0-9\b]+$/;

    //console.log("test mfa code", regex.test(value));

    if (value === '' || regex.test(value)) {
      setEmailMfaToken(e.target.value);
    }
  }

  // api to verify the email
  const verifyEmailToken = async () => {
    const res = await mfaVerifyToken(loginInfo.mfaToken, {
      mfaToken: emailMfaToken,
      userFactor: "EMAIL"
    });

    //console.log("verifyEmailToken()", res);

    if (res && res.data.status === 200) {
      if (res.data) {
        dispatch(setToken(res.data.headers["authorization"]));
        dispatch(setFirstName(res.data.data.data?.firstName));
        dispatch(setLastName(res.data.data.data?.lastName));
        dispatch(setPsoName(res.data.data.data?.psoName));
        dispatch(setLastLoginDate(res.data.data.data?.lastLoginDateString));
        // !!! pointed to the role info
        dispatch(setRole(res.data.data.data?.userRole?.roleName));

        var userRole = res.data.data.data?.userRole?.roleName;
        if (userRole == ROLES.L1.id || userRole == ROLES.AUSER.id) {
          navigate("/helpcenter");
        }
        else {
          navigate("/dashboard");
        }
      }
    } else {
      setGlobalErrorList(res.data.data?.globalErrorMessageList);
    }
  }

  const cancelMfa = () => {
    setEmailMfaToken("");
    setShowSendCodeMsg(false);
    setDisableSendCode(false);
    setDisableMfaTokenField(true);
    dispatch(setMfaToken(""));
    handleClose();
  }

  return (
    <Modal
      id="email-mfa-token-popup"
      className="modal"
      size="lg"
      backdrop="static"
      show={show}
      centered
    >
      <Modal.Header className="ps-5 pe-5 pt-5">
        <Modal.Title>
          <h2 className="pb-3">
            <CloseButton
              className="closeup-popup-button"
              onClick={cancelMfa}
            >
            </CloseButton>
          </h2>
          <h2 className="text-start title">Two-Factor Authentication</h2>
          <h6 className="text-start subtitle mt-3">
            To begin the verification process, please confirm your email address.
          </h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4 pb-5 ps-5 pe-5">
        {showSendCodeMsg ?
          <PageInfo type="info" message={"A code has been sent to the email address associated with your account. Please enter that code in the field below. It may take up to 2 minutes to receive this code. If you do not see the email after 2 minutes, please check your spam folder."}></PageInfo>
          : null}
        {globalErrorList.map((item, index) =>
          <>
            <Row className="pt-4"></Row>
            <PageInfo key={"errors_" + index} type="error" message={item}></PageInfo>
          </>
        )}
        <Form
          className="pt-4"

        >
          <Row className="mb-3">
            <Col sm="7" className="mfa-setting-label pt-1">
              <div class="mfa-setting-step">
                <span>1.</span>
                <span>Click to send code to <span className="email-label">{maskEMail(loginInfo?.username)}</span>.</span>
              </div>
            </Col>
            <Col>
              <TextButton
                disabled={disableSendCode}
                variant="normal"
                onClick={handleEmailSendCode}
                content={"Send Code"}
              >
              </TextButton>
            </Col>
          </Row >
          <br />
          <Form.Group as={Row} className="mb-3" controlId="mfaToken">
            <Form.Label column sm="7" className="mfa-setting-label">
              2. Enter the six digit code.
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                style={{ width: "7rem" }}
                ref={tokenInputRef}
                disabled={disableMfaTokenField}
                type="text"
                maxlength={6}
                value={emailMfaToken}
                onChange={handleEmailMfaChange}
              />
            </Col>
          </Form.Group>
          <br />
          <Row className="mb-3 pt-1">
            <Col sm="7" className="mfa-setting-label pt-1">3. Click Verify to confirm.</Col>
            <Col>
              <TextButton
                className="w-10"
                variant="normal"
                disabled={emailMfaToken.length !== 6}
                onClick={verifyEmailToken}
                content={"Verify"}
              >
              </TextButton>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <TextButton
                className="w-10"
                variant="outline"
                onClick={cancelMfa}
                content={"Cancel"}
              >
              </TextButton>
            </Col>
          </Row>
        </Form >
      </Modal.Body>
    </Modal>
  )
}

export default EmailMfaTokenPopup;